module.exports = "<div class=\"alert alert-danger\" role=\"alert\">\n  <h1 ng-bind=\"'FORBIDDEN' | translate\"></h1>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/errors/forbidden/forbidden.html
 ** module id = 349
 ** module chunks = 0
 **/